import axios from "axios";

const { CancelToken } = axios;
const cancelTokens = {};

const api = axios.create({
  baseUrl: wbConfig.baseUrl,
  headers: {
    "X-Requested-With": "XMLHttpRequest"
  }
});

// Cancel token keys are request URL without params
const cancelAndGenerateToken = request => {
  const token = CancelToken.source();
  const { url: tokenKey } = request;

  // cancel previous request
  cancelTokens[tokenKey] &&
    cancelTokens[tokenKey].cancel("Operation canceled due to new request.");

  // update token for new request
  cancelTokens[tokenKey] = token;

  return token.token;
};

// Request inteceptor for auto-cancel
api.interceptors.request.use(request => {
  if (request.cancelable === true) {
    request.cancelToken = cancelAndGenerateToken(request);
  }

  return request;
});

// Response inteceptor for auto-cancel
api.interceptors.response.use(response => {
  const { url: tokenKey } = response.config;

  cancelTokens[tokenKey] && delete cancelTokens[tokenKey];

  return response;
});

export default api;
